module.exports = __webpack_public_path__ + "img/guide-to-share.23323c7.jpg";